import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vant from 'vant'
import 'vant/lib/index.css'
import VueLuckyCanvas from '@lucky-canvas/vue'
import { registerServiceWorker } from '@/utils/registerServiceWorker'
import { consumeTokenFromUrl } from '@/utils/tokenLogin'
import { getToken, removeUserInfo } from '@/utils/auth'
import { clearApiCache } from '@/utils/apiCache'

function applyUrlTokenToStore() {
  const usedAdminLoginLink = consumeTokenFromUrl()
  const token = getToken()
  if (token) {
    store.commit('user/SET_TOKEN', token)
    if (usedAdminLoginLink) {
      removeUserInfo()
      store.commit('user/SET_USER_INFO', null)
      clearApiCache()
    }
  }
  return usedAdminLoginLink
}

async function initApp() {
  // 必须先消费 URL token，再挂载路由（否则会被踢去 /login 并丢掉 ?token=）
  applyUrlTokenToStore()

  const app = createApp(App)

  try {
    // store 必须在 router 之前，保证守卫里 dispatch 时状态已同步
    app.use(store)
    app.use(router)
    app.use(vant)
    app.use(VueLuckyCanvas)

    await router.isReady()
    app.mount('#app')

    store.dispatch('config/bootstrapWebViewConfig')
    registerServiceWorker()
  } catch (error) {
    console.error('应用初始化失败:', error)
  }
}

initApp()

export { applyUrlTokenToStore }
